module.exports = __webpack_public_path__ + "img/face-grin-hearts.da06c535.svg";